const OperatingSystems = {
        android: 'Android',
        ios: 'iOS',
        unknown: 'unknown'
    },
    Browsers = {
        chrome: 'chrome',
        firefox: 'firefox',
        safari: 'safari',
        ie: 'internet explorer',
        edge: 'edge',
        opera: 'opera'
    },

    /**
     * Returns browsers name.
     *
     * @return {string} - Browser name.
     */
    browserName = () => {
        const userAgent = navigator.userAgent;

        if (/MSIE/i.test(userAgent) || /rv:11.0/i.test(userAgent) ) {
            return Browsers.ie;
        }
        if (/Edge/i.test(userAgent)) {
            return Browsers.edge;
        }
        if (/Opera|OPR/i.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
            return Browsers.opera;
        }
        if (/Chrome/i.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
            return Browsers.chrome;
        }
        if (/Safari/i.test(userAgent) && /Apple/.test(navigator.vendor)) {
            return Browsers.safari;
        }
        if (/Firefox/i.test(userAgent)) {
            return Browsers.firefox;
        }
        return '';
    },

    /**
     * Checks users OS.
     *
     * @return {string} - OS name.
     */
    operatingSystem = () => {

        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            return OperatingSystems.android;
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return OperatingSystems.ios;
        }

        return OperatingSystems.unknown;
    },

    /**
     * Checks whether user uses mobile browser.
     *
     * @return {boolean} - True or false.
     */
    isMobile = () => {

        let os = operatingSystem();

        var isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
        
        return (os === OperatingSystems.android || os === OperatingSystems.ios || isIPadPro);
    },

    /**
     * Checks whether user uses Internet Explorer.
     *
     * @return {boolean} - True or false.
     */
    isIE = () => {
        return (/MSIE/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent));
    },

    isSafari = () => {
        return browserName() === Browsers.safari;
    };

export {
    OperatingSystems,
    isMobile,
    isIE,
    isSafari,
    browserName
};

export default operatingSystem;


// WEBPACK FOOTER //
// ./src/js/lib/checkuseros.js